import { render, staticRenderFns } from "./protocol-entry.vue?vue&type=template&id=1b83431b&scoped=true&"
import script from "./protocol-entry.vue?vue&type=script&lang=js&"
export * from "./protocol-entry.vue?vue&type=script&lang=js&"
import style0 from "./protocol-entry.vue?vue&type=style&index=0&lang=css&"
import style1 from "./protocol-entry.vue?vue&type=style&index=1&id=1b83431b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83431b",
  null
  
)

export default component.exports